module.exports = __webpack_public_path__ + "img/Group 97965.430e381e.png";